/** @format */

import { connect } from "react-redux";
import { TEXT_DIRECTION } from "../../helper/helperFunctions";
import HeaderBar from "../head/HeaderBar";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

function WrapperContainer({ children, collapsed, setCollapsed, setOpenNotification, currentRoute, openNotification }) {
  const location = useLocation();
  const scrollRef = useRef(null);
  const savedScrollRef = useRef(0);
  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const isFormsListPath = location.pathname === "/forms/form-management" || location.pathname === "/forms/form-management/";

  const isFormViewPath = location.pathname.includes("/form-management/") && location.pathname.includes("/view");

  // Save scroll before leaving forms list
  useEffect(() => {
    if (isFormViewPath) {
      // Coming from forms list to view — restore saved scroll immediately
      const el = scrollRef.current;
      if (el && savedScrollRef.current > 0) {
        el.scrollTop = savedScrollRef.current;
      }
    }
  }, [isFormViewPath]);

  // Restore scroll when returning to forms list
  useEffect(() => {
    if (isFormsListPath) {
      const el = scrollRef.current;
      if (el && savedScrollRef.current > 0) {
        el.scrollTop = savedScrollRef.current;
        setTimeout(() => {
          el.scrollTop = savedScrollRef.current;
        }, 50);
        setTimeout(() => {
          el.scrollTop = savedScrollRef.current;
        }, 150);
      }
    }
  }, [isFormsListPath]);

  const hiddenHeaderBar =
    location.pathname.includes("/start/") ||
    location.pathname.includes("/password-reset-message-email") ||
    location.pathname.includes("/forms/form-management/dispatch/") ||
    location.pathname.includes("/homepage") ||
    location.pathname.includes("/privacy-policy") ||
    location.pathname.includes("/terms-and-conditions") ||
    location.pathname.includes("/report-pdf-view") ||
    // Report edit (inspection-edit) renders its own back-arrow header, just like
    // the Start-inspection screen — hide the global header so it isn't doubled.
    // Scoped to /reports/.../edit/ so it never affects /management/*/edit pages.
    (location.pathname.includes("/reports/") && location.pathname.includes("/edit/"));
  return (
    <div
      className="w-full"
      onClick={(e) => {
        if (!collapsed) {
          toggleNavbar();
        }
      }}
    >
      <HeaderBar
        setOpenNotification={setOpenNotification}
        toggleNavbar={toggleNavbar}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        openNotification={openNotification}
      />

      <div
        ref={scrollRef}
        data-scroll-container="forms"
        onScroll={() => {
          if ((location.pathname === "/forms/form-management" || location.pathname === "/forms/form-management/") && scrollRef.current) {
            savedScrollRef.current = scrollRef.current.scrollTop;
            sessionStorage.setItem("formsListScrollY", String(scrollRef.current.scrollTop));
          }
        }}
        className={`${
          hiddenHeaderBar
            ? ""
            : !currentRoute?.enableBack
              ? `${currentRoute?.step1 === "Analytics" ? "mt-[49px]" : "mt-[60px]"}  w-[100%] h-[89vh] overflow-y-auto ${
                  TEXT_DIRECTION() === "ltr"
                    ? "md:pl-[60px] lg:pl-[60px] xl:pl-[60px] sm:pl-[0px]"
                    : "md:pr-[60px] lg:pr-[60px] xl:pr-[60px] sm:pr-[0px]"
                }`
              : "mt-[49px]"
        }`}
      >
        {children}
      </div>
    </div>
  );
}

const mapStateToProps = ({ authentication }) => ({
  currentRoute: authentication.currentRoute,
});

export default connect(mapStateToProps)(WrapperContainer);
